import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { Restaurant as IngredientIcon, AutoAwesome as AIIcon } from "@mui/icons-material";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyIngredientsProps = {
  onAddIngredient: () => void;
};

const EmptyIngredients = ({ onAddIngredient }: EmptyIngredientsProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptyIngredientsView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="Create your ingredient database with nutritional information to build accurate and detailed recipes."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500, alignItems: "center" }} spacing={2}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Add ingredients with protein, carb, and fat values per unit. Use AI to automatically 
            populate nutritional data, or enter it manually. These ingredients power your recipe creation.
          </Typography>
          
          <Stack direction="row" spacing={2}>
            <StandardButton
              data-testid="EmptyIngredientsView-Button"
              variant="primary"
              startIcon={<IngredientIcon />}
              onClick={() => {
                onAddIngredient();
                events.logButtonClick({
                  buttonName: "Add Your First Ingredient",
                  pageName: "Nutrition",
                  tabName: "Ingredients",
                });
              }}
              style={{ fontSize: 16 }}
            >
              Add Your First Ingredient
            </StandardButton>
          </Stack>
          
          <Typography variant="caption" color="text.secondary" style={{ textAlign: "center", marginTop: 8 }}>
            <AIIcon sx={{ fontSize: 14, mr: 0.5 }} />
            Pro tip: After adding an ingredient, use the "AI Fill Nutrition" button to automatically populate nutritional values
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyIngredients;